module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_1_4-fb8e059f7c1a9f2e7777f6f80c3bd799.png";